export default "__VITE_ASSET__DAoNYRm___"